module.exports = __webpack_public_path__ + "static/media/home_chef.66a6b1b1.png";